import { render, staticRenderFns } from "./SGScriptSummary.vue?vue&type=template&id=0dba1544"
import script from "./SGScriptSummary.vue?vue&type=script&lang=js"
export * from "./SGScriptSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports